export default __webpack_public_path__ + "static/media/md8-op-ex.d6093aee.svg";